export default "__VITE_ASSET__Cevm9tdk__"